<template>
  <div>
    <v-data-iterator
      :items="results"
      sort-by="user.lastName"
      :search="search"
      :sort-desc="false"
      :items-per-page="35"
      :custom-filter="filter"
      :footer-props="footerProps"
      :group-by.sync="groupBySelector.value"
    >
      <template v-slot:default="props">
        <v-card flat>
          <div v-for="(group, index) in props.groupedItems" :key="index">
            <v-divider></v-divider>
            <v-subheader
              :class="
                $vuetify.theme.dark
                  ? 'grey darken-2 font-weight-medium'
                  : 'grey lighten-3 font-weight-medium'
              "
              style="height: 32px"
            >
              {{ group.items[0].groupByDisplayText[groupBySelector.value] }}
            </v-subheader>
            <v-divider></v-divider>
            <div v-for="(result, i) in group.items" :key="result.user.uid">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">{{
                    result.user.displayName
                  }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action-text>
                  <performance-target-status-chip
                    :status="result.totalPerformanceTargetResultStatus"
                    small
                    class="mr-1"
                  ></performance-target-status-chip>
                  <performance-target-traffic-light
                    :status="result.trafficLightStatus"
                    small
                  ></performance-target-traffic-light>
                </v-list-item-action-text>
                <v-list-item-action>
                  <v-btn
                    text
                    outlined
                    small
                    @click="toggleDetailsDialog(result)"
                    ><v-icon small>mdi-calculator-variant</v-icon></v-btn
                  >
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="group.items.length !== i + 1"></v-divider>
            </div>
          </div>
        </v-card>
      </template>
    </v-data-iterator>
    <!-- Performance Target Results Details Dialog -->
    <CustomDialog
      v-if="helpers.detailsDialog.model"
      @close="toggleDetailsDialog()"
      title="Berechnungsdetails"
      fullscreenOnMobile
      width="l"
      hideActionBtn
      showCloseBtn
    >
      <template v-slot:content>
        <performance-target-results-details-content
          v-if="helpers.detailsDialog.data"
          :user-data="helpers.detailsDialog.data"
        ></performance-target-results-details-content>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import PerformanceTargetStatusChip from "@/components/member-management/performance-targets/PerformanceTargetStatusChip.vue";
import PerformanceTargetTrafficLight from "@/components/member-management/performance-targets/PerformanceTargetTrafficLight.vue";
import PerformanceTargetResultsDetailsContent from "@/components/member-management/performance-targets/PerformanceTargetResultsDetailsDialog.vue";
import CustomDialog from "@/components/_systemwide/CustomDialog.vue";
export default {
  name: "performance-targets-results-list",
  props: {
    results: {
      type: Array,
      required: true,
    },
    search: {
      type: String,
      required: false,
    },
    groupBySelector: {
      type: Object,
      required: true,
    },
  },
  components: {
    PerformanceTargetStatusChip,
    PerformanceTargetTrafficLight,
    PerformanceTargetResultsDetailsContent,
    CustomDialog,
  },
  data() {
    return {
      helpers: {
        dataIsLoading: false,

        detailsDialog: {
          model: false,
          data: null,
        },
      },
      footerProps: {
        "items-per-page-options": [25, 40, 50, 100, -1],
      },
    };
  },
  computed: {
    reports() {
      return this.$store.state.dutyManagement.reports;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {},
    filter(items, search) {
      if (!search) return items;
      const searchLower = search.toLowerCase();
      return items.filter((item) => {
        return Object.values(item).some((prop) => {
          if (typeof prop === "object" && prop !== null) {
            return Object.values(prop).some((subProp) =>
              String(subProp).toLowerCase().includes(searchLower)
            );
          }
          return String(prop).toLowerCase().includes(searchLower);
        });
      });
    },
    stripPrefix(item) {
      return item.substring(item.indexOf("_") + 1);
    },
    async toggleDetailsDialog(item) {
      if (item) {
        this.helpers.detailsDialog.data = item;
      }
      this.helpers.detailsDialog.model = !this.helpers.detailsDialog.model;
    },
  },
};
</script>
